import _classCallCheck from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _pt from "prop-types";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
import { css } from '@patternfly/react-styles';
import { keyHandler } from '../../helpers/util';
import { DropdownPosition, DropdownArrowContext, DropdownContext } from './dropdownConstants';
export var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownMenu, _React$Component);

  function DropdownMenu() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DropdownMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DropdownMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "refsCollection", []);

    _defineProperty(_assertThisInitialized(_this), "childKeyHandler", function (index, position) {
      var custom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      keyHandler(index, position, _this.refsCollection, _this.props.isGrouped ? _this.refsCollection : React.Children.toArray(_this.props.children), custom);
    });

    _defineProperty(_assertThisInitialized(_this), "sendRef", function (index, node, isDisabled, isSeparator) {
      if (!node.getAttribute) {
        // eslint-disable-line react/no-find-dom-node
        _this.refsCollection[index] = ReactDOM.findDOMNode(node);
      } else if (isDisabled || isSeparator) {
        _this.refsCollection[index] = null;
      } else {
        _this.refsCollection[index] = node;
      }
    });

    return _this;
  }

  _createClass(DropdownMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoFocus = this.props.autoFocus;

      if (this.props.component === 'ul' && autoFocus) {
        var focusTarget = this.refsCollection.find(function (ref) {
          return ref && !ref.hasAttribute('disabled');
        });

        if (focusTarget) {
          if (focusTarget.focus) {
            focusTarget.focus();
          } else {
            var searchedFocusTarget = ReactDOM.findDOMNode(focusTarget);
            searchedFocusTarget.focus();
          }
        } else if (focusTarget) {// eslint-disable-line react/no-find-dom-node
        }
      }
    }
  }, {
    key: "extendChildren",
    value: function extendChildren() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          isGrouped = _this$props2.isGrouped;

      if (isGrouped) {
        var index = 0;
        return React.Children.map(children, function (groupedChildren) {
          var group = groupedChildren;
          return React.cloneElement(group, _objectSpread({}, group.props && group.props.children && {
            children: group.props.children.constructor === Array && React.Children.map(group.props.children, function (option) {
              return React.cloneElement(option, {
                index: index++
              });
            }) || React.cloneElement(group.props.children, {
              index: index++
            })
          }));
        });
      }

      return React.Children.map(children, function (child, index) {
        return React.cloneElement(child, {
          index: index
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          isOpen = _this$props.isOpen,
          position = _this$props.position,
          children = _this$props.children,
          component = _this$props.component,
          isGrouped = _this$props.isGrouped,
          openedOnEnter = _this$props.openedOnEnter,
          props = _objectWithoutProperties(_this$props, ["className", "isOpen", "position", "children", "component", "isGrouped", "openedOnEnter"]);

      return React.createElement(DropdownArrowContext.Provider, {
        value: {
          keyHandler: this.childKeyHandler,
          sendRef: this.sendRef
        }
      }, component === 'div' ? React.createElement(DropdownContext.Consumer, null, function (_ref) {
        var onSelect = _ref.onSelect,
            menuClass = _ref.menuClass;
        return React.createElement("div", {
          className: css(menuClass, position === DropdownPosition.right && styles.modifiers.alignRight, className),
          hidden: !isOpen,
          onClick: function onClick(event) {
            return onSelect && onSelect(event);
          }
        }, children);
      }) : isGrouped && React.createElement(DropdownContext.Consumer, null, function (_ref2) {
        var menuClass = _ref2.menuClass,
            menuComponent = _ref2.menuComponent;
        var MenuComponent = menuComponent || 'div';
        return React.createElement(MenuComponent, _extends({}, props, {
          className: css(menuClass, position === DropdownPosition.right && styles.modifiers.alignRight, className),
          hidden: !isOpen,
          role: "menu"
        }), _this2.extendChildren());
      }) || React.createElement(DropdownContext.Consumer, null, function (_ref3) {
        var menuClass = _ref3.menuClass,
            menuComponent = _ref3.menuComponent;
        var MenuComponent = menuComponent || component;
        return React.createElement(MenuComponent, _extends({}, props, {
          className: css(menuClass, position === DropdownPosition.right && styles.modifiers.alignRight, className),
          hidden: !isOpen,
          role: "menu"
        }), _this2.extendChildren());
      }));
    }
  }]);

  return DropdownMenu;
}(React.Component);

_defineProperty(DropdownMenu, "propTypes", {
  children: _pt.node,
  className: _pt.string,
  isOpen: _pt.bool,
  openedOnEnter: _pt.bool,
  autoFocus: _pt.bool,
  component: _pt.node,
  position: _pt.oneOfType([_pt.any, _pt.oneOf(['right']), _pt.oneOf(['left'])]),
  isGrouped: _pt.bool
});

_defineProperty(DropdownMenu, "defaultProps", {
  className: '',
  isOpen: true,
  openedOnEnter: false,
  autoFocus: true,
  position: DropdownPosition.left,
  component: 'ul',
  isGrouped: false
});